import { PlayerComponentCSSStyleImpl } from '../../player/playercss';

export class ToneRowPlayerComponentCSSStyleImpl extends PlayerComponentCSSStyleImpl
{
    getPlayDivCSSStyle(): object 
    {
        return {
            // width:'79px',

            height:'100%',
            border:'none',
            cursor: "pointer",
            // borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // padding:'22px'
        };
    }

    getPlayIconCSSStyle(): object 
    {
        return {
            height: "28px",
            width: "28px",
            cursor: "pointer",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowplayercss.tsx